var Handlebars = require("/root/project/webapp/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    return "bottom";
},"3":function(container,depth0,helpers,partials,data) {
    return "left";
},"5":function(container,depth0,helpers,partials,data) {
    return "    <span class=\"badge sidebar-nav-badge\">"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.badgeContent : depth0), depth0))
    + "</span>\n";
},"7":function(container,depth0,helpers,partials,data) {
    return "    <span class=\"unread-indicator\"></span>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.escapeExpression;

  return "<div data-toggle=\"tooltip\"\n     data-placement=\""
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.horizontal : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data})) != null ? stack1 : "")
    + "\"\n     title=\""
    + alias2(__default(require("/root/project/webapp/src/common/ui/template/helper/i18n.js")).call(alias1,(depth0 != null ? depth0.label : depth0),{"name":"i18n","hash":{},"data":data}))
    + "\" style=\"position: relative;\">\n    <i class=\""
    + alias2(container.lambda((depth0 != null ? depth0.icon : depth0), depth0))
    + "\"></i>\n"
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.badge : depth0),{"name":"if","hash":{},"fn":container.program(5, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.unread : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./common/ui/template/sidebar/nav.hbs
// module id = 857
// module chunks = 0